interface InterJourneyIconProps {
  width?: string | number;
  height?: string | number;
  color?: string;
}

const InterJourneyIcon: React.FC<InterJourneyIconProps> = ({
  width = 18,
  height = 18,
  color = "#4F4F52",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3425 7.85251V13.3425C13.3425 15.09 11.925 16.5 10.185 16.5H4.6575C2.9175 16.5 1.5 15.0825 1.5 13.3425V7.85251C1.5 6.10501 2.9175 4.69501 4.6575 4.69501H10.185C11.925 4.69501 13.3425 6.11251 13.3425 7.85251Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.125 3V1.6875"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.125 3V1.6875"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.125 3V1.6875"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.5 9.86999C16.5 11.61 15.0825 13.0275 13.3425 13.0275V6.71249C15.0825 6.71249 16.5 8.12249 16.5 9.86999Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.5 9H13.1325"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default InterJourneyIcon;
